<style lang="scss" scoped>
</style>

<template>
  <div>
    <div class="sidebar-title is-size-5 pb-4">Edit User</div>
    <form @submit.prevent="submit" novalidate>
      <c-text-input v-model="data.email" label="Email" type="email" :error="errors.email"/>
      <c-text-input v-model="data.password" label="Password" type="password" autocomplete="new-password"
                    :error="errors.password"/>
      <!-- requested to show "roles" here not to create role system on backend, but instead a superadmin flag -->
      <c-select-input v-if="editor.is_superadmin" v-model="data.role" label="Role"
                      :options="{user: 'user', admin: 'admin', superadmin: 'superadmin'}"/>
      <c-select-input v-else-if="user.is_superadmin && editor.is_superuser" v-model="data.role" label="Role"
                      :options="{user: 'user', admin: 'admin', superadmin: 'superadmin'}" :disabled="true"/>
      <c-select-input v-else v-model="data.role" label="Role"
                      :options="{user: 'user', admin: 'admin'}"/>
      <div class="pt-5">
        <button class="button is-primary is-fullwidth">Save</button>
      </div>
    </form>
  </div>
</template>

<script>
import { pick } from 'lodash';
import { get } from 'vuex-pathify';
import api from '@/api';


export default {
  name: 'update-user-form',
  props: ['user'],
  data () {
    return {
      data: pick(this.user, ['email', 'is_superuser', 'is_superadmin', 'role']),
      errors: {}
    };
  },
  watch: {
    user() {
      this.data = pick(this.user, ['email', 'is_superuser', 'is_superadmin', 'role']);
      this.errors = {};
    }
  },
  computed: {
    editor: get('user'),
  },
  methods: {
    async submit() {
      try {
        await api.admin.users.update(this.user.id, this.data);
        this.errors = {};
        this.data = {};
        this.$emit('complete');
      } catch (error) {
        this.handle(error);
      }
    },
    handle(error) {
      const errors = error.data;
      this.errors = {};
      if (errors.email)
        this.errors.email = 'Please enter a valid unique email address.';
      if (errors.password)
        this.errors.password = 'Please enter a password with numbers, letters, capitols and at least 8 characters.';
      if (errors.is_superuser)
        this.errors.is_superuser = "There was a problem setting this user's admin status.";
      if (errors.is_superadmin)
        this.errors.is_superadmin = "There was a problem setting this user's super admin status.";
    }
  }
};
</script>
